import * as React from 'react';
import { BudgetExpenseOrIncome } from 'business/constants';
import BudgetWithAccessCheck from 'components/ModuleAccess/BudgetWithAccessCheck';
import { Navigate, useParams } from 'react-router-dom';
import Resource from 'routes/BudgetModule/components/BudgetProposal/Resource/Resource';
import BudgetWithProvider from 'routes/BudgetModule/components/BudgetWithProvider/BudgetWithProvider';

type Props = {
    hasBudget: boolean;
    isBudgetUser: boolean;
};

export default function ResourceWithRouting({
    hasBudget,
    isBudgetUser,
}: Props) {
    const { budgetProposalId, resourceSoftwareId, tab } = useParams();

    if (tab === 'projection') {
        return (
            <Navigate
                to={`/budget_proposal/${budgetProposalId}/resource/${resourceSoftwareId}/${tab}/atterrissage`}
                replace
            />
        );
    }

    // Expense and income tab must have a view by params in their path, that's
    // why we always redirect the user to the page with a view By parameter
    if (Object.values(BudgetExpenseOrIncome).includes(tab?.toUpperCase())) {
        return (
            <Navigate
                to={`/budget_proposal/${budgetProposalId}/resource/${resourceSoftwareId}/${tab}/imputations`}
                replace
            />
        );
    }
    // Otherwise some other tabs don't need this param and don't need to be redirected
    // For exemple : Analyse
    return (
        <BudgetWithAccessCheck
            hasBudget={hasBudget}
            isBudgetUser={isBudgetUser}
        >
            <BudgetWithProvider>
                <Resource />
            </BudgetWithProvider>
        </BudgetWithAccessCheck>
    );
}
